<template>
  <rd-container size="large">
    <!-- {{getAvaliablePortals}}
        {{sideNavData}}-->
    <div class="d-flex">
      <div style="display: flex; flex-direction: column">
        <rd-side-nav :data="navData" />
        <Links
          :linksList="linksArray"
          :linksHeader="linksHeader"
          @addLink="addLinkHandler"
          @editLink="editLinkHandler"
          @deleteLink="deleteLinkHandler"
          @listReorder="listReorderHandler"
        >
        </Links>
      </div>
      <div class="content">
        <div class="row">
          <div class="col-xs-12">
            <router-view :key="$route.fullPath" />
          </div>
        </div>
      </div>
    </div>
  </rd-container>
</template>
<script>
import Links from "../components/links/Index.vue";
import { mapFields } from "vuex-map-fields";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import commonMessages from "../../locales";
import localMessages from "../locales";

const name = "membershipStores/appRolesStores/indexStore";


const INDEX_STORE = "dashboardStores/dashboardStores/indexStore";

export default {
  name: "appRolesList",
  data() {
    return {
      navName: "rdSideNav",
      // navData: [],
      sideNavData: [
        {
          title: "Dashboard",
          linkTo: { name: "myPortal.dashboard" },
          icon: "far fa-columns",
        },
        /*{
                        title: "Rezerwacje",
                        linkTo: "/rezerwacje",
                        icon: "far fa-calendar-alt"
                    },*/
        {
          title: this.$t('index.captions.addressBook'),
          linkTo: { name: "myPortal.addressBook" },
          icon: "far fa-id-card",
        },
        {
          alias: "knowledgeBase",
          title: this.$t('index.captions.knowledgeBase'),
          linkTo: { name: "" },
          icon: "far fa-book-alt",
          data: null,
        },
        /*{
                        title: "Projekty",
                        linkTo: "/projekty",
                        icon: "far fa-project-diagram"
                    },*/
        // {
        //     title: "HR",
        //     linkTo: { name: 'myPortal.hr' },
        //     icon: 'far fa-users'
        // },
        // {
        //     title: "Premie i wynagrodzenia",
        //     linkTo: { name: 'myPortal.bonuses' },
        //     icon: 'far fa-money-bill-wave'
        // }
      ],
    };
  },
  computed: {
    ...mapGetters(INDEX_STORE, [
      "getLinksData",
      "getIsManager",
      "getIsBonusAcceptant",
    ]),
    ...mapState(["isTreeListVisible"]),
    ...mapState(INDEX_STORE, ["linksArray", "linksHeader", "navData"]),
    // navData() {
    //     return this.updateNavData();
    // }
  },
  methods: {
    ...mapMutations(INDEX_STORE, ["setNavData"]),
    ...mapActions(INDEX_STORE, [
      "setLinks",
      "addLinkItem",
      "editLinkItem",
      "deleteLinkItem",
      "reorderList",
      "setIsManager",
      "setIsBonusAcceptant",
    ]),
    addLinkHandler: function (e) {
      this.addLinkItem(e);
    },
    editLinkHandler: function (e) {
      this.editLinkItem(e);
    },
    deleteLinkHandler: function (e) {
      this.deleteLinkItem(e);
    },
    listReorderHandler: function (e) {
      this.reorderList(e);
    },
    updateNavData() {
      let teamShown = false;
      const vm = this;
      this.setAvaliablePortalsForTree().then(() => {
        this.setIsManager().then(() => {
          this.sideNavData.forEach((e) => {
            if (e.alias == "knowledgeBase") {
              e.data = [];
              if (e.data.length <= 0) e.data = null;
            }

            if (e.alias == "team") teamShown = true;
          });


          if (teamShown == false && vm.getIsManager)
            vm.sideNavData.push({
              title: this.$t('index.captions.team'),
              linkTo: { name: "" },
              icon: "far fa-users",
              alias: "team",
              data: [
                {
                  title: this.$t('index.captions.workers'),
                  linkTo: { name: "myPortal.team" },
                },
                //...this.getIsBonusAcceptant ? [{
                //    title: "Premie i wynagrodzenia",
                //    linkTo: { name: 'myPortal.bonuses' }
                //}] : [],
                {
                  title: this.$t('index.captions.importantTerms'),
                  linkTo: { name: "myPortal.terms" },
                },
              ],
            });
          if (
            vm.getIsBonusAcceptant &&
            !vm.sideNavData
              .find((x) => x.alias == "team")
              .data.some((x) => x.title == this.$t('index.captions.bonusAndSalary'))
          ) {
            vm.sideNavData
              .find((x) => x.alias == "team")
              .data.splice(1, 0, {
                title: this.$t('index.captions.bonusAndSalary'),
                linkTo: { name: "myPortal.bonuses" },
              });
          }
        });
      });
      return this.sideNavData;
    },
  },
  created() {
    this.setLoaded(() => {});
    if (!this.navData.length) {
      const data = this.updateNavData();
      this.setNavData(data);

      this.setIsBonusAcceptant();
    }
  },
  mounted() {
    this.setLinks();
  },
  components: {
    Links,
  },
  i18n: {
    messages: localMessages.messages,
    sharedMessages: commonMessages.messages,
  },
};
</script>